'use client'

import { useConfigsContext } from '@/context/ConfigsContext'
import { Link } from '@/i18n/navigation'
import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'

export default function AiDisclaimer() {
  const t = useTranslations()
  const { appConfig } = useConfigsContext()

  const { viverse_landing } = appConfig?.links || {}
  const viverseDomain = viverse_landing?.replace(/\/$/, '')

  return (
    <motion.section
      className="bg-background relative flex items-center justify-center px-8 py-4"
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 1, ease: 'easeOut' }}
    >
      <div className="text-vive-primary-30 text-center text-xs tracking-[0.2px]">
        {t.rich('partner.ai-disclaimer.text-1', {
          term: t('partner.ai-disclaimer.text-2'),
          a: (chunks) => (
            <Link
              href={`${viverseDomain}/terms-of-use`}
              className="text-vive-brand-50 hover:text-vive-brand-40 active:text-vive-brand-60 inline-flex w-fit items-center gap-2 underline transition-all"
            >
              {chunks}
            </Link>
          ),
        })}
      </div>
    </motion.section>
  )
}
